export default __webpack_public_path__ + "static/media/2004.372fb1d7.png";